import { useTheme } from './ThemeContext';
import type { Theme } from './ThemeContext';

const OPTIONS: { value: Theme; label: string; description: string }[] = [
  {
    value: 'auto',
    label: 'System (auto)',
    description: 'Follows your OS appearance preference.',
  },
  {
    value: 'light',
    label: 'Light',
    description: 'Always light, regardless of OS setting.',
  },
  {
    value: 'dark',
    label: 'Dark',
    description: 'Always dark, regardless of OS setting.',
  },
];

export function ThemeSection() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="settings-section">
      <h3>Appearance</h3>
      <fieldset
        className="theme-section-fieldset"
        aria-describedby="theme-section-help"
      >
        <legend className="settings-monospace settings-stub-cli-hidden">
          Theme
        </legend>
        {OPTIONS.map((opt) => (
          <label key={opt.value} className="theme-section-option">
            <input
              type="radio"
              name="tizok-theme"
              value={opt.value}
              checked={theme === opt.value}
              onChange={() => setTheme(opt.value)}
            />
            <span className="theme-section-option-body">
              <span className="theme-section-option-label">{opt.label}</span>
              <span className="theme-section-option-description">
                {opt.description}
              </span>
            </span>
          </label>
        ))}
      </fieldset>
      <p id="theme-section-help" className="settings-hint">
        Saved on this device.
      </p>
    </div>
  );
}
